type ScheduleBackgroundTaskOptions = {
  delay?: number;
  timeout?: number;
};

type BrowserWindowWithIdleCallback = Window & {
  requestIdleCallback?: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
};

export function scheduleBackgroundTask(task: () => void, options: ScheduleBackgroundTaskOptions = {}) {
  if (typeof window === "undefined") {
    task();
    return;
  }

  const { delay = 0, timeout = 2000 } = options;
  const browserWindow = window as BrowserWindowWithIdleCallback;

  if (typeof browserWindow.requestIdleCallback === "function") {
    browserWindow.requestIdleCallback(() => task(), { timeout });
    return;
  }

  globalThis.setTimeout(task, delay);
}
